import VehicleIdentifierBox from "./vehicleIdentifierBox";

export default VehicleIdentifierBox;